import { Button, Modal } from "semantic-ui-react"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faClose } from "@fortawesome/pro-solid-svg-icons"
import { faGift } from "@fortawesome/pro-regular-svg-icons"
import { ReactComponent as TreadingUp } from "../../../images/TrendingUp.svg"
import { ReactComponent as Award } from "../../../images/Award.svg"
import { ReactComponent as Star } from "../../../images/Star-full.svg"
import { withRouter } from "react-router-dom"
import { connect } from "react-redux"
import { routerPaths } from "../../../v1/constants/paths"

const RewardsWelcomeModal = ({ openModal, closeModal, history }) => {
  const onAction = (route) => {
    if (route) {
      history.push(route)
    }
    closeModal && closeModal()
  }

  return (
    <Modal open={openModal} className="rewards-welcome-modal">
      <Modal.Content className="modal-content">
        <div className="modal-header">
          <div className="header-icon">
            <Star width={50} height={50} />
          </div>

          <div className="close-btn" onClick={onAction}>
            <FontAwesomeIcon icon={faClose} color="white" />
          </div>
        </div>

        <div className="modal-body">
          <h1 className="title">Welcome to CarAdvise Rewards!</h1>

          <p className="subtitle">
            Earn points on every visit and turn your maintenance into major savings.
          </p>

          <div className="features">
            <div className="feature-row">
              <div className="feature-icon">
                <FontAwesomeIcon icon={faGift} color="#E95832" />
              </div>
              <div>
                <p className="feature-title">Earn on Every Visit</p>
                <p className="feature-desc">Get rewarded for the maintenance you already do</p>
              </div>
            </div>

            <div className="feature-row">
              <div className="feature-icon">
                <TreadingUp color="#E95832" />
              </div>
              <div>
                <p className="feature-title">Build Your Balance</p>
                <p className="feature-desc">
                  Watch your Points add up and help cover future repairs
                </p>
              </div>
            </div>

            <div className="feature-row">
              <div className="feature-icon">
                <Award color="#E95832" />
              </div>
              <div>
                <p className="feature-title">Redeem Anytime</p>
                <p className="feature-desc">
                  Apply your savings instantly for a win at the register
                </p>
              </div>
            </div>
          </div>

          <Button className="primary-cta" onClick={() => onAction(routerPaths.serviceRequest)}>
            Start Earning Points
          </Button>

          <p className="learn-more" onClick={() => onAction(routerPaths.rewards)}>
            Learn More
          </p>
        </div>
      </Modal.Content>
    </Modal>
  )
}

export default withRouter(connect()(RewardsWelcomeModal))
